<div class="content-header">
  <div>
    <h1>AdLink Management</h1>
  </div>
  <div>
    @if (authStore.canEdit()) {
      <sdc-button
        variant="primary"
        [attr.data-cy]="'adlink-create-button'"
        (onClick)="openModalCreate()">
        Create New AdLink
      </sdc-button>
    }
  </div>
</div>

@if (refreshing) {
  <div class="loading">
    <div class="text-container">
      <div>
        <span>Loading Adlinks</span>
      </div>
      <div>
        <div class="dot-typing"></div>
      </div>
    </div>
  </div>
}

<gs-table [data]="data" [columns]="columns"></gs-table>

<p class="legend">
  Showing {{ data.length }} of {{ totalItemsInDb }} total AdLinks
</p>
<app-pagination
  [currentPage]="currentPage"
  [totalItemsInDb]="totalItemsInDb"
  [itemsPerPage]="itemsPerPage"
  #pagination></app-pagination>
